import { ENCOUNTER_TYPES_API, type Encounter } from '@/types/encounter';
import { getDrugScreenTimeWindowsData } from '@/utils/drugScreenTimeWindows';

/**
 * Whether this encounter has a drug screen to show, or is inside the window for
 * taking one. Read by the section around the card as well, which cannot draw a
 * heading over a card that is about to render nothing.
 */
const hasDrugScreenCard = (encounter?: Encounter) =>
  encounter?.encounter_type === ENCOUNTER_TYPES_API.APPOINTMENT_ATTENDANCE &&
  !!(
    encounter?.drug_screens?.length ||
    getDrugScreenTimeWindowsData(encounter?.appointment).isDrugScreenButtonEnabled
  );

export default hasDrugScreenCard;
